import { render, staticRenderFns } from "./AsesoresRemake.vue?vue&type=template&id=19ea48b0&"
import script from "./AsesoresRemake.vue?vue&type=script&lang=js&"
export * from "./AsesoresRemake.vue?vue&type=script&lang=js&"
import style0 from "./AsesoresRemake.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports